<template>
  <section class="LKPublicationsMunMeh">
    <h3
      class="LKPublicationsMunMeh__title"
      v-text="data.name"
    />

    <div class="LKMunMehCardForm">
      <div class="LKMunMehCardForm__inner-wrapper">
        <div class="LKMunMehCardForm__row">
          <div class="LKMunMehCardForm__left">
            <LKMunMehCardFormLeft
              :data="data"
              :disabled="isDisabled"
              :expert="isExpert"
              :curator="isCurator"
              :spectator="isSpectator"
            />
          </div>

          <div class="LKMunMehCardForm__right">
            <LKMunMehCardFormRight
              :data="data"
              :disabled="isDisabled"
              :expert="isExpert"
              :curator="isCurator"
              :spectator="isSpectator"
              :slug="slug"
            />
          </div>
        </div>
        <LKMunMehCardProgress
          v-if="isExpert"
          :mun-meh-id="data.id"
        />
      </div>
    </div>
  </section>
</template>

<script>
import LKMunMehCardFormLeft from './LKMunMehCardFormLeft.vue'
import LKMunMehCardFormRight from './LKMunMehCardFormRight.vue'
import LKMunMehCardProgress from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCardProgress.vue'
import { isAfterToday, isBeforeToday } from '@/helpers/dateFormatter'
import { lkMapper } from '@/store/modules/lk'


export default {
  name: 'LKMunMehCardForm',
  components: {
    LKMunMehCardProgress,
    LKMunMehCardFormLeft,
    LKMunMehCardFormRight,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    slug: String,
  },
  computed: {
    ...lkMapper.mapGetters(['profile']),
    isDisabled() {
      const { data, profile } = this
      const { start_at, end_at } = data

      const isStartDatesBeforeToday = (!start_at || isAfterToday(start_at, profile.msk_diff))
      const isEndDatesAfterToday = (!end_at || isBeforeToday(end_at, profile.msk_diff))
      return isStartDatesBeforeToday || isEndDatesAfterToday
    },
    isCurator() {
      return !!this.data.is_curator || this.profile.is_superuser
    },
    isExpert() {
      return !!this.data.is_expert
    },
    isSpectator() {
      return (!!this.data.is_spectator && !this.isCurator) || this.profile.is_federal_level
    },
  },

}
</script>

<style lang="scss">
$border-color: #bcd5fa;

.LKPublicationsMunMeh {
  border-top: 3px solid $border-color;

  &__title {
    padding: 20px 0;
    font-size: 18px;
    font-weight: bold;
    color: $webflow-color-blue-dark-3;
  }
}

.LKMunMehCardForm {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: $webflow-color-blue-shadow;

  &__inner-wrapper {
    padding: 18px 22px 25px 22px;
    overflow-x: auto;
  }

  &__row {
    display: flex;
    flex-direction: row;
  }

  &__left {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  &__right {
    padding-left: 24px;
    margin-left: 24px;
    border-left: 1px solid $webflow-color-blue-light;
  }
}
</style>
